import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import '../../styles/login.css';
import { useThemeMode } from '../../ThemeContext';
// Assets
import CompanyIcon from '../../assets/iccompany.svg';
import IndividualIcon from '../../assets/icindividual.svg';
import ChevronRight from '../../assets/chevron-right.svg';
import LoginBanner1 from '../../assets/loginban1.png';
import Logo from '../../assets/logo.svg';

function Signup() {
  const { mode } = useThemeMode();
  const [accountType, setAccountType] = useState('');
  const [acceptedPolicies, setAcceptedPolicies] = useState(false);
  const navigate = useNavigate();

  const handleSelect = (type) => setAccountType(type);
  const handleContinue = () => {
    if (accountType) {
      if (accountType === 'company') {
        navigate('/company-signup');
      } else if (accountType === 'individual') {
        navigate('/individual-signup');
      }
    }
  };

  return (
    <div className={`login-body ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
      <Container fluid className="login-container">
        <Row className="g-0 min-vh-100">
          {/* Left Side: Image/Overlay */}
          <Col lg={6} className="d-none d-lg-block login-left-bg position-relative">
            <div className="login-slider-img-wrap position-absolute w-100 h-100">
              <Image src={LoginBanner1} alt="Signup Banner" className="login-slider-img" fluid />
            </div>
            <div className="login-left-overlay"></div>
          </Col>
          {/* Right Side: Signup Form */}
          <Col xs={12} lg={6} className="d-flex align-items-center justify-content-center login-right-bg position-relative">
            <div className="login-blur-bg-top"></div>
            <div className="login-blur-bg-bottom"></div>
            <div className="login-form-wrapper w-100" style={{ maxWidth: '486px' }}>
              {/* Logo at top (helps on mobile and desktop) */}
              <div className="text-center mb-4" style={{ marginTop: 32 }}>
                <Image
                  src={Logo}
                  alt="Complimate Logo"
                  className="login-logo-main mb-3"
                  style={{ height: '72px', cursor: 'pointer' }}
                  onClick={() => navigate('/')}
                />
              </div>
              <div className="mb-4 text-center">
                <h2 className="login-title" style={{ color: mode === 'dark' ? '#26c3c0' : '#009391' }}>Create Your Complimate Account</h2>
                <div className="login-subtitle" style={{ color: mode === 'dark' ? '#8a8a8a' : '#666' }}>Start by choosing your account type to continue.</div>
              </div>
              <div className="mb-4">
                <Row className="g-3">
                  <Col xs={12}>
                    <div
                      className={`account-type-card selectable-card${accountType === 'company' ? ' selected' : ''}`}
                      tabIndex={0}
                      onClick={() => handleSelect('company')}
                      style={{ cursor: 'pointer' }}>
                      <div className="d-flex align-items-center gap-3">
                        <span className="account-type-icon">
                          <Image src={CompanyIcon} alt="Company" width={50} height={50} />
                        </span>
                        <div>
                          <div className="fw-bold text-white">I'm registering as a Company</div>
                          <div className="text-secondary small">Add team, manage roles, and handle compliance.</div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div
                      className={`account-type-card selectable-card${accountType === 'individual' ? ' selected' : ''}`}
                      tabIndex={0}
                      onClick={() => handleSelect('individual')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <span className="account-type-icon">
                          <Image src={IndividualIcon} alt="Individual" width={50} height={50} />
                        </span>
                        <div>
                          <div className="fw-bold text-white">I'm registering as an Individual</div>
                          <div className="text-secondary small">For personal, freelance, or solo use.</div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              {/* Policies acceptance */}
              <div className="mb-3" style={{ color: mode === 'dark' ? '#ccc' : '#444', fontSize: '14px' }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={acceptedPolicies}
                    onChange={(e) => setAcceptedPolicies(e.target.checked)}
                    style={{ marginTop: 4 }}
                  />
                  <span>
                    I agree to the{' '}
                    <Link to="/terms" style={{ color: mode === 'dark' ? '#26c3c0' : '#009391' }}>Terms & Conditions</Link>
                    {' '}and{' '}
                    <Link to="/privacy" style={{ color: mode === 'dark' ? '#26c3c0' : '#009391' }}>Privacy Policy</Link>.
                  </span>
                </label>
              </div>

              <Button
                type="button"
                className="btn btn-teal w-100 login-btn d-flex align-items-center justify-content-center mb-3"
                onClick={handleContinue}
                disabled={!accountType || !acceptedPolicies}
              >
                Continue
                <span className="ms-2">
                  <Image src={ChevronRight} alt="chevron" style={{ height: '14px' }} />
                </span>
              </Button>
              <div className="text-center mb-4">
                <span className="login-signup-text">
                  Already have an account?{' '}
                  <Link to="/login" className="login-signup-link">Sign in here</Link>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Signup; 